<template>
  <div class="specs-picker">
    <TransitionFade body-scroll-lock>
      <SpecsModal
        :show-modal='specsModalVisible'
        :groups="groups"
        :allow-select-group='allowSelectGroup'
        :can-reset='canReset'
        :max-selected-categories-count="maxSelectedCategoriesCount"
        :selected-categories="modelValue"
        :category-field-name='categoryFieldName'
        :user-categories-data="userCategoriesData"
        @close="specsModalVisible = false"
        @update:data="onUpdateData"
      />
    </TransitionFade>
    <div
      @click="openModal"
      class="specs-picker__specs"
      :class="bem('specs-picker__specs', { collapsed: selectedOptions.length > 4, hasError })"
    >
      <FiltersList
        v-if="selectedOptions.length"
        nowrap
        :filters="selectedOptions"
        @remove="resetOne($event)"
      />
      <span v-else class="specs-picker__specs-placeholder">Выберите специализацию
      </span>
    </div>
  </div>
</template>

<script>
  import { bem } from 'src/utils/bem.js';
  import { createPropModel,modelValueConfig } from 'src/utils/vue.js';

  import FiltersList from 'src/components/filters/FiltersList/FiltersList.vue';
  import SpecsModal from 'src/components/resumes/SpecsModal/SpecsModal.vue';
  import TransitionFade from 'src/components/transitions/TransitionFade/TransitionFade.vue';

  export default {
    name: 'SpecsPicker',
    components: { FiltersList, SpecsModal, TransitionFade },
    model: modelValueConfig(),
    props: {
      modelValue: Array,
      selectedCategories: {
        type: Array,
        default: () => [],
      },
      allowSelectGroup: {
        type: Boolean,
        default: false,
      },
      canReset: {
        type: Boolean,
        default: true,
      },
      maxSelectedCategoriesCount: {
        type: Number,
        default: 1,
      },
      categoryFieldName: {
        type: String,
        default: 'sc',
      },
      sOptions: Array,
      groups: {
        type: Array,
        required: true,
      },
      userCategoriesData: {
        type: Object,
        default: () => ({}),
      },
      error: {
        type: String,
        default: null,
      },
    },
    emits: ['update:modelValue'],
    data() {
      return {
        specsModalVisible: false,
        hasError: !!this.error,
      }
    },

    methods: {
      onUpdateData(data) {
        const hiddenInput = this.getHiddenInput();
        this.removeError(hiddenInput);
        this.updateInputValue(hiddenInput, data);
        this.model = data;
      },
      getHiddenInput() {
        const nextSibling = this.$el.nextElementSibling;
        if (!nextSibling) return null;
        
        if (nextSibling.tagName !== 'INPUT') {
          return nextSibling.querySelector('input[type="hidden"]');
        }
        
        return nextSibling;
      },
      removeError(hiddenInput) {
        this.hasError = false;
        let fieldError = this.$el.nextElementSibling;
        if (!fieldError) {
          fieldError = this.$el.parentElement.nextElementSibling;
        }

        if (fieldError && fieldError.classList.contains('field_error')) {
          if (hiddenInput) {
            fieldError.parentElement.appendChild(hiddenInput);
          }
          fieldError.remove();
        }
      },
      updateInputValue(hiddenInput, data) {
        if (hiddenInput) {
          // eslint-disable-next-line no-param-reassign,prefer-destructuring
          hiddenInput.value = data[0] || '';
        }
      },
      openModal(event) {
        // фикс, чтобы не останавливать всплытие события remove в FilterItem
        if (typeof event.target.className !== 'string'
          || (!event.target.className.includes('specs-picker')
          && event.target.className !== 'filter-item__title')) return;
        
        this.specsModalVisible = true;
        window.history.pushState(null, null, window.location.href);
      },
      resetOne(data) {
        const filteredData = this.selectedCategories.filter(selectedId => selectedId !== data.value);
        this.onUpdateData(filteredData);
      },
      bem,
    },
    
    computed: {
      selectedOptions() {
        return this.sOptions.filter(option => this.selectedCategories.indexOf(option.value) !== -1 && option);
      },
      model: createPropModel('modelValue'),
    },
  }
</script>